module.exports = __webpack_public_path__ + "img/pink heart.f7558bd9.png";